import { gql } from "@apollo/client";

export const GET_COMPETITIONS_SIMPLE = gql`
  query Query($filter: JSON, $offset: Int, $limit: Int, $sort: [[String]]) {
    competitions(filter: $filter, offset: $offset, limit: $limit, sort: $sort) {
      items {
        id
        name
        start_date
        zipcode
        city
        department
      }
    }
  }
`;
